import React from "react";
import {Pane} from "evergreen-ui";

export default function Constructor({ children }) {
    return (
        <Pane
            display="grid"
            gridTemplateColumns="max-content 1fr"
        >
            {children}
        </Pane>

    );
}